/* api/linalg */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    tslib_1.__exportStar(require(35) /* ../core/util/object */, exports);
    tslib_1.__exportStar(require(24) /* ../core/util/array */, exports);
    tslib_1.__exportStar(require(40) /* ../core/util/string */, exports);
    tslib_1.__exportStar(require(435) /* ../core/util/random */, exports);
    tslib_1.__exportStar(require(46) /* ../core/util/types */, exports);
    tslib_1.__exportStar(require(33) /* ../core/util/eq */, exports);
}
